import { StreamingPlatform } from 'types';
import { TWITCH_RTMP_URL } from 'utils';
import { FacebookState, PlatformState, TwitchState, YoutubeState } from 'store/slices/streamingPlatforms';
import { api } from 'services';

export const generateYoutubeStreamingEndpoint = async (eventName: string, state?: YoutubeState): Promise<string> => {
  const {
    data: { id: broadcastId }
  } = await api.requests.youtube.createBroadcast({ title: eventName });
  const {
    data: {
      id: streamId,
      cdn: {
        ingestionInfo: { rtmpsIngestionAddress, streamName }
      }
    }
  } = await api.requests.youtube.createStream({ title: eventName });

  await api.requests.youtube.bindBroadcastToStream({ id: broadcastId, streamId });

  const rtmpUrl = `${rtmpsIngestionAddress}/${streamName}`;

  return rtmpUrl;
};

export const generateFacebookStreamingEndpoint = async (eventName: string, state?: FacebookState): Promise<string> => {
  const userId = state?.userId as number;

  if (!userId) throw new Error('facebook userId is not found');

  const response = await api.requests.facebook.createBroadcast({
    userId,
    title: eventName
  });
  const rtmpUrl = response.data.secure_stream_url;

  return rtmpUrl;
};

export const generateTwitchStreamingEndpoint = async (eventName: string, state?: TwitchState): Promise<string> => {
  const broadcasterId = await api.requests.twitch.getBroadcasterId();
  const streamKey = await api.requests.twitch.getStreamKey({ broadcasterId });
  const rtmpUrl = `${TWITCH_RTMP_URL}/${streamKey}`;

  return rtmpUrl;
};

export const generateStreamingEndpoint = async ({
  platform,
  eventName,
  state
}: {
  platform: StreamingPlatform;
  eventName: string;
  state?: PlatformState;
}): Promise<string> => {
  switch (platform) {
    case StreamingPlatform.FACEBOOK: {
      const url = await generateFacebookStreamingEndpoint(eventName, state as FacebookState);

      return url;
    }

    case StreamingPlatform.YOUTUBE: {
      const url = await generateYoutubeStreamingEndpoint(eventName, state as YoutubeState);

      return url;
    }

    case StreamingPlatform.TWITCH: {
      const url = await generateTwitchStreamingEndpoint(eventName, state as TwitchState);

      return url;
    }

    default:
      return '';
  }
};
